import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { Close, MoreIcon, PauseIcon, PlayIcon } from 'src/icons/icons'
import ClickAwayListener from 'react-click-away-listener';
import { ExtendVisa } from 'src/components/visaActions/ExtendVisa';
import { CancelVisas } from 'src/components/visaActions/CancelVisas';
import { CrewListItem } from 'src/types';
import { DeleteVisa } from 'src/components/visaActions/DeleteVisa';

const ActionButton = ({ icon: Icon, title }: { icon: typeof MoreIcon, title: string }) => <div className='flex text-right flex-row items-center  gap-2.5 cursor-pointer  z-50'>
    <Icon className='size-5' color='black' />
    <span className='text-right'>{title}</span>
</div>

export const CrewVisaOperations = ({ crewData, agentVisaId, onSuccessMutate, isResidence }: { crewData: CrewListItem, agentVisaId: string, onSuccessMutate: Function, isResidence: boolean }) => {

    const { t } = useTranslation();

    const [isOpen, setIsOpen] = useState<boolean>(false)

    return (
        <div className='relative text-center '>

            <MoreIcon className='cursor-pointer size-6 text-black ' onClick={() => setIsOpen(true)} />

            {isOpen && <ClickAwayListener onClickAway={() => setIsOpen(false)}><div className='flex flex-col gap-4 absolute right-full translate-x-9 top-full border bg-white border-gray-100 z-30 rounded-lg shadow p-2.5 whitespace-nowrap'>

                {isResidence && <ExtendVisa crewsData={[{ id: crewData.crew_id, job_id: crewData.job.id }]} duplicate_visa_id={agentVisaId} onSuccessMutate={onSuccessMutate}> <ActionButton icon={PlayIcon} title={t('extend')} /></ExtendVisa>
                }
                <CancelVisas crows={[crewData]} onSuccessMutate={onSuccessMutate} agentVisaId={agentVisaId} ><ActionButton icon={PauseIcon} title={t('cancel')} /></CancelVisas>

                <DeleteVisa onSuccessMutate={onSuccessMutate} visaId={agentVisaId} ><ActionButton icon={Close} title={t('delete')} /></DeleteVisa>


            </div></ClickAwayListener >}

        </div>
    )
}
